// extracted by css-extract-rspack-plugin
export default {"root":"root-QCs5wy"};